module.exports = __webpack_public_path__ + "assets/fonts/segoeui-bold-2c47175b890a2788244dbbb04fd15810.woff2";